import React, { useEffect, useState } from 'react';
import { getScrapingRuns, getScrapingRecords, triggerScraping } from '../../api';
import { useToast } from '../../components/Toast';

export default function AdminScraping() {
  const toast = useToast();
  const [runs, setRuns] = useState([]);
  const [records, setRecords] = useState([]);
  const [triggering, setTriggering] = useState(false);
  const [tab, setTab] = useState('runs');
  const [filter, setFilter] = useState('');

  const load = () => {
    getScrapingRuns().then(setRuns).catch(console.error);
    getScrapingRecords(filter ? { status: filter } : undefined).then(setRecords).catch(console.error);
  };
  useEffect(() => { load(); }, [filter]);

  const handleTrigger = async (source) => {
    setTriggering(true);
    try {
      const result = await triggerScraping(source);
      toast.success(`Scraping terminé ! ${result.total_found} trouvées, ${result.eligible} éligibles, ${result.rejected} rejetées, ${result.duplicates} doublons.`);
      load();
    } catch (err) { toast.error(err.message); }
    setTriggering(false);
  };

  return (
    <div style={{ padding: '32px 0' }}>
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div>
            <h1 style={{ marginBottom: 4 }}>Moteur de Référencement (Scraping)</h1>
            <p style={{ color: 'var(--text-light)', fontSize: 14 }}>Pré-référencement automatisé depuis Pappers, Société.com, Infogreffe</p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {['pappers', 'societe', 'infogreffe'].map(src => (
              <button key={src} onClick={() => handleTrigger(src)} className="btn btn-accent" disabled={triggering} style={{ fontSize: 12, textTransform: 'capitalize' }}>
                {triggering ? '...' : `Scraper ${src}`}
              </button>
            ))}
          </div>
        </div>

        <div className="tab-bar">
          {[{ key: 'runs', label: `Historique (${runs.length})` }, { key: 'records', label: `Startups scrapées (${records.length})` }].map(t => (
            <button key={t.key} onClick={() => setTab(t.key)}
              style={{ padding: '12px 24px', border: 'none', background: 'none', cursor: 'pointer',
                fontFamily: 'inherit', fontSize: 14, fontWeight: 600,
                borderBottom: `3px solid ${tab === t.key ? 'var(--primary-light)' : 'transparent'}`,
                color: tab === t.key ? 'var(--primary)' : 'var(--text-light)', marginBottom: -2 }}>
              {t.label}
            </button>
          ))}
        </div>

        {tab === 'runs' && (
          <div style={{ display: 'grid', gap: 8 }}>
            {runs.map(r => (
              <div key={r.id} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <strong style={{ textTransform: 'capitalize' }}>{r.source}</strong>
                  <span className={`badge ${r.status === 'completed' ? 'badge-vert' : 'badge-orange'}`} style={{ marginLeft: 8, fontSize: 11 }}>{r.status}</span>
                  <div style={{ fontSize: 12, color: 'var(--text-light)', marginTop: 4 }}>
                    {r.started_at ? new Date(r.started_at).toLocaleString('fr-FR') : '-'}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 20 }}>
                  <div style={{ textAlign: 'center' }}><div style={{ fontWeight: 700 }}>{r.total_found}</div><div style={{ fontSize: 11, color: 'var(--text-light)' }}>Trouvées</div></div>
                  <div style={{ textAlign: 'center' }}><div style={{ fontWeight: 700, color: '#27AE60' }}>{r.total_eligible}</div><div style={{ fontSize: 11, color: 'var(--text-light)' }}>Éligibles</div></div>
                  <div style={{ textAlign: 'center' }}><div style={{ fontWeight: 700, color: '#E74C3C' }}>{r.total_rejected}</div><div style={{ fontSize: 11, color: 'var(--text-light)' }}>Rejetées</div></div>
                  <div style={{ textAlign: 'center' }}><div style={{ fontWeight: 700, color: '#95A5A6' }}>{r.total_duplicates}</div><div style={{ fontSize: 11, color: 'var(--text-light)' }}>Doublons</div></div>
                </div>
              </div>
            ))}
          </div>
        )}

        {tab === 'records' && (
          <>
            <div style={{ marginBottom: 16 }}>
              <select value={filter} onChange={e => setFilter(e.target.value)} className="form-input" style={{ maxWidth: 200 }}>
                <option value="">Tous</option>
                <option value="eligible">Éligibles</option>
                <option value="rejected">Rejetées</option>
              </select>
            </div>
            <div style={{ display: 'grid', gap: 8 }}>
              {records.map(r => (
                <div key={r.id} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  borderLeft: `4px solid ${r.eligibility_status === 'eligible' ? '#27AE60' : '#E74C3C'}` }}>
                  <div>
                    <strong>{r.raison_sociale || r.startup_name || 'N/A'}</strong>
                    <div style={{ fontSize: 12, color: 'var(--text-light)', marginTop: 4 }}>
                      SIREN: {r.siren} · Source: {r.source} · {new Date(r.scraped_at).toLocaleDateString('fr-FR')}
                    </div>
                    {r.rejection_reason && <div style={{ fontSize: 12, color: '#E74C3C', marginTop: 2 }}>{r.rejection_reason}</div>}
                  </div>
                  <span className={`badge ${r.eligibility_status === 'eligible' ? 'badge-vert' : 'badge-rouge'}`} style={{ fontSize: 11 }}>
                    {r.eligibility_status}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
